import { Controller } from "@hotwired/stimulus"
import { post, get } from "@rails/request.js"
import Toastify from 'toastify-js';

export default class extends Controller {
  static targets = ["course", "modality", "ingressType", "teachingLevel", "duration", "state", "city", "pole", "citiesDiv", "form", "duration", "courses", "courseTitle", "search", "loadingPoles"]

  connect (){
    let urlParams = new URLSearchParams(window.location.search);
    this.loadCourses(document.getElementById(`teaching_level_${urlParams.get('formacao')}`));
    this.coursesPath = `${window.location.origin}/courses`;
    this.offersPath = `${window.location.origin}/offers`;
    this.verifyEdit();
  }

  async loadCourses(e) {
    if (e === null)
      return;

    const courses = await this.fetchCourses(e);

    this.scrollTo(document.getElementById('courses'));
    let params = new URLSearchParams(document.location.search);
    let courseParam = params.get("curso");
    this.searchTarget.value = '';
    if (courseParam === null)
      return;

    setTimeout(() => {
      this.courseTargets.forEach(course => {
        if (course.dataset.code == courseParam) {
          course.checked = true;
          this.searchTarget.value = course.dataset.title;
          this.searchCourses();
        }
      });
      this.loadCourseData();
    }, 500);
  }

  async fetchCourses(e) {
    const selectedOption = e.currentTarget === undefined ? e : e.currentTarget;
    const dataUrl = selectedOption.getAttribute('data-url');

    if (dataUrl == null)
      return [];

    await get(dataUrl)
  }


  async loadCourseData() {
    const response = await this.fetchCourse();
    this.filterCourse();
    this.dispatch('course');
    window.scroll(
      {
        top: document.getElementById('course-next').offsetTop,
        behavior: 'smooth'
      }
    )
    this.resetFields('pole');
  }

  filterCourse() {
    this.courseTargets.forEach(course => {
      if (course.checked) {
        this.searchTarget.value = course.dataset.title;
        this.searchCourses();
      }
    });
  }

  scrollBottom() {
    if (window.location.href.match(/editar/)) {
      window.scroll(
        {
          top: document.getElementById('course-next').offsetTop,
          behavior: 'smooth'
        }
      )
    }
  }

  async fetchCourse() {
    const courseId = this.courseTargets.find(option => option.checked);
    if (courseId === undefined) return;
    this.courseTitleTarget.innerHTML = courseId.getAttribute('data-title');

    let params = new URLSearchParams({
      teaching_level_id: document.querySelector('input[name*=teaching_level_id]:checked').value,
    });

    await get(`${this.coursesPath}/${courseId?.value}.turbo_stream?${params.toString()}`);
  }

  async loadPoles(e) {
    let selectedOption = e.target.dataset.name;
    this.resetFields('city');
    this.resetFields('pole');
    if (selectedOption === 'Selecione a modalidade') {
      return;
    } else if (selectedOption === 'Presencial' || selectedOption === 'Semipresencial') {
      this.citiesDivTarget.style.display = "none";
      this.fetchPoles(e, 'presencial');
    } else {
      this.citiesDivTarget.style.display = "";
    }
    this.dispatch('modality');
  }
  async loadPolesWithCity(e) {
    this.fetchPoles(e);
  }

  async fetchPoles(e, modality = '') {
    const courseId = this.courseTargets.find(option => option.checked);
    const modalityId = this.modalityTargets.find(option => option.checked);
    const teachingLevelId = this.teachingLevelTargets.find(option => option.checked);

    let params = new URLSearchParams({
      course_id: courseId ? courseId.value : null,
      city_id: modality !== 'presencial' ? this.cityTarget.value : '',
      teaching_level_id: teachingLevelId ? teachingLevelId.value : null,
      modality_id: modalityId ? modalityId.value : null,
    });
    this.loadingPolesTarget.classList.remove('hidden');
    this.resetFields('pole');
    const response = await get(`${this.offersPath}/poles?${params.toString()}`).then(response => {
      this.loadingPolesTarget.classList.add('hidden');
    }
    );
  }
  async loadDurations(e) {
    const durationRadio = document.querySelectorAll('input[name*=duration_id]').forEach(duration => duration.remove());
    const response = await this.fetchDurations(e);

    setTimeout(() => {
      this.ingressTypeTargets.forEach(ingressType => {
        const ingressTypeElement = document.querySelector(`label[for*=ingress_type_id_${ingressType.value}]`);
        const durationElement = document.getElementById(`duration_${ingressType.value}`);
        const turboElement = document.getElementById(`ref_ingress_type_duration_${ingressType.value}`);
        const durationRadio = document.querySelectorAll('input[name*=duration_id]');

        if (ingressType.checked) {
          ingressTypeElement.classList.add('border-[#0080C9]', 'rounded-b-none');
          durationElement.style.display = "";

          if (durationRadio.length == 1) {
            durationRadio[0].checked = true;
          }
        } else {
          ingressTypeElement.classList.remove('border-[#0080C9]', 'rounded-b-none');
          ingressTypeElement.classList.add('border-gray-200');
          turboElement.innerHTML = '';
          durationElement.style.display = "none";
        }
      });
    }, 100);
  }

  async fetchDurations(e) {
    const courseId = this.courseTargets.find(option => option.checked);
    const modalityId = this.modalityTargets.find(option => option.checked);
    const teachingLevelId = this.teachingLevelTargets.find(option => option.checked);
    const ingressTypeId = this.ingressTypeTargets.find(option => option.checked);

    let params = new URLSearchParams({
      course_id: courseId?.value,
      teaching_level_id: teachingLevelId?.value,
      modality_id: modalityId?.value,
      ingress_type_id: ingressTypeId?.value,
    });
    await get(`${this.coursesPath}/durations.turbo_stream?${params.toString()}`);
    this.dispatch('ingress-type');
  }

  resetFields(field) {
    if (field === 'modality') {
      this.modalityTarget.innerHTML = '';
    } else if (field === 'ingress_type') {
      document.querySelector('#ingress_types').innerHTML = '';
    } else if (field === 'duration') {
      this.durationTarget.innerHTML = '';
    } else if (field === 'city') {
      this.stateTarget.value = '';
      this.cityTarget.value = '';
      this.cityTarget.parentElement.style.display = 'none';
    } else if (field === 'pole') {
      document.getElementById('poles').innerHTML = '';
    }
  }

  scrollBottomPole() {
    const visibleButton = [...document.querySelectorAll('.btn-next')].find(el => {
      return el.offsetParent !== null && getComputedStyle(el).visibility !== 'hidden';
    });
    this.scrollTo(visibleButton);
  }

  async verifyOffer(event) {
    event.preventDefault();

    const durationId = this.durationTargets.find(option => option.checked);
    if (durationId === undefined) {
      this.toaster("Selecione a duração");
      return;
    }

    let response = await this.fetchOffer();

    if (response != null) {
      if (!response.active_offer) {
        Toastify({
          gravity: "bottom",
          position: 'right',
          style: { background: "#102f6d" },
          close: true,
          destination: `${window.location.origin}/interesse`,
          text: "Infelizmente, não temos essa oferta disponível no momento. Registramos seu interesse e assim que tivermos uma nova turma, entraremos em contato.",
          
          duration: 6000
          
        }).showToast();

        setTimeout(() => {
          window.location.href = `${window.location.origin}/interesse`;
        }, 3000);
        return;
      }
    }

    this.formTarget.submit();
  }

  async fetchOffer() {
    const courseId = this.courseTargets.find(option => option.checked);
    const modalityId = this.modalityTargets.find(option => option.checked);
    const teachingLevelId = this.teachingLevelTargets.find(option => option.checked);
    const ingressTypeId = this.ingressTypeTargets.find(option => option.checked);
    const durationId = this.durationTargets.find(option => option.checked);

    if (courseId === undefined || modalityId === undefined || ingressTypeId === undefined || durationId === undefined || teachingLevelId === undefined) {
      return;
    }

    let response = await post(`${this.offersPath}/verify`, {
      body: JSON.stringify({
        course_id: courseId?.value,
        modality_id: modalityId?.value,
        ingress_type_id: ingressTypeId?.value,
        duration_id: durationId?.value,
        teaching_level_id: teachingLevelId?.value,
        city_id: this.cityTarget.value,
        pole_id: document.querySelector('input[name*=pole_id]:checked')?.value
      })}
    )
    return await response.json;
  }

  loadIngressTypes(e) {
    this.resetFields('ingress_type');
    this.fetchIngressTypes();
  }

  async fetchIngressTypes() {
    const courseId = this.courseTargets.find(option => option.checked);
    const modalityId = this.modalityTargets.find(option => option.checked);
    const teachingLevelId = this.teachingLevelTargets.find(option => option.checked);

    let params = new URLSearchParams({
      course_id: courseId?.value,
      teaching_level_id: teachingLevelId?.value,
      modality_id: modalityId?.value,
    });
    await get(`${this.coursesPath}/ingress_types.turbo_stream?${params.toString()}`);
  }

  searchCourses () {
    let search = this.searchTarget.value;

    this.courseTargets.forEach(course => {
      if (course.dataset.title.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().includes(search.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase())) {
        course.parentElement.style.display = "";
      } else {
        course.parentElement.style.display = "none";
      }
    });
  }

  scrollTo(element) {
    setTimeout(() => {
      window.scroll(
        {
          top: element.offsetTop,
          behavior: 'smooth'
        }
      )
    }, 100);  
  }

  toaster(message) {
    Toastify({
      gravity: "bottom",
      position: 'right',
      style: { background: "#102f6d" },
      close: true,
      text: message,
      
      duration: 3000
    }).showToast();
  }

  dispatch(step, action = 'active') {
    this.element.dispatchEvent(new CustomEvent("stepbar:update", { 
      detail: { step: step, action: action }, 
      bubbles: true 
    }));
  }

  verifyEdit() {
    const that = this;
    if (window.location.href.match(/editar/)) {
      that.dispatch('course');
      that.dispatch('modality');
      that.dispatch('ingress-type');
      that.dispatch('pole');
    }
  }
}
